import {onInViewport} from '../../../utils/onInViewport';

export const initSectionCds2ComplexDescription = () => {
	const components = Array.from(document.querySelectorAll(`section.cds2-complex-description`));

	if ( components.length )
	{
		components.forEach((component) => {
			const onWindowScroll = onInViewport(component, () => window.removeEventListener(`scroll`, onWindowScroll));
			onWindowScroll();
			window.addEventListener(`scroll`, onWindowScroll);
			
			const bookletWrapperSelector = 'div.booklet-wrapper';
			const bookletButtonSelector = `${bookletWrapperSelector} > button.toggle`;
			
			const bookletWrapper = component.querySelector( bookletWrapperSelector );
			const bookletButton = component.querySelector( bookletButtonSelector );
			
			if ( bookletWrapper && bookletButton )
			{
				const bookletOpenedClass = 'open';
				
				const toggleBookletOpenClass = ( evt ) => {
					evt.preventDefault();
					evt.stopPropagation();
					evt.stopImmediatePropagation();
					
					bookletWrapper.classList.toggle( bookletOpenedClass );
				};
				
				bookletButton.addEventListener( 'mousedown', toggleBookletOpenClass );
				bookletButton.addEventListener( 'touchstart', toggleBookletOpenClass );
				
				document.addEventListener( 'click', ( evt ) => {
					if( !evt.target.closest( bookletWrapperSelector ) )
					{
						bookletWrapper.classList.remove( bookletOpenedClass );
					}
				} );
				
				bookletWrapper.addEventListener( 'mouseenter', () => {
					if ( !bookletWrapper.classList.contains( bookletOpenedClass ) )
					{
						bookletWrapper.classList.add( bookletOpenedClass );
					}
				} );
				
				bookletWrapper.addEventListener( 'mouseleave', () => {
					if ( bookletWrapper.classList.contains( bookletOpenedClass ) )
					{
						bookletWrapper.classList.remove( bookletOpenedClass );
					}
				} );
			}
		});
	}
};
